<template>
    <div id="date_picker_modal" class="ui basic modal datetimerange">
        <div v-if="is_initialized">
            <div class="content">
                <Option v-for="(option, index) in options"
                    :key="index"
                    :type="type"
                    :index="index+1"
                    :is_date="is_date"
                    :option="option"
                    v-model="times">
                </Option>
                <DatatimePicker
                    :index="0"
                    :is_date="is_date"
                    :re_init="is_datatime_picker_re_init"
                    :type="type"
                    v-model="times">
                </DatatimePicker>
            </div>
            <div class="ui header">
                <div class="actions"
                    style="display: flex; justify-content: space-between;">
                    <div class="">
                        <div class="ui ok red inverted button"
                        @click="times=['',''];update_value()">
                            <i class="close icon"></i>
                            {{ $t('ui.el.datepicker.clear') }}
                        </div>
                    </div>

                    <div style="text-align: right;">
                        <div class="ui ok inverted button">
                            {{ $t('ui.el.datepicker.cancel') }}
                        </div>
                        <div class="ui green ok inverted button"
                            @click="update_value()"
                            style="margin-left: .75em;margin-top: .3em;">
                            <i class="checkmark icon"></i>
                            {{ $t('ui.el.datepicker.confirm') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Option from '@toolbox/date_picker_modal/option.vue'
import DatatimePicker from '@toolbox/date_picker_modal/datatime_picker.vue'

export default {
    components: {
        Option,
        DatatimePicker
    },
    props: {
        channel: String,
        type: {
            type: String,
            default: () => { return 'daterange' }
        },
        options: {
            type: Array,
            default: () => { return [] }
        },
    },
    data() {
        return {
            is_initialized: false,
            is_datatime_picker_re_init: false,
            current_index: null,
            times: [],
        }
    },
    computed: {
        is_date() {
            return this.type == 'datetime'
        },
    },
    watch: {
        is_date(val) {
            this.$forceUpdate()
            this.init()
        },
        times(val) {
            this.is_datatime_picker_re_init = !this.is_datatime_picker_re_init
            this.$forceUpdate()
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        update_value() {
            if (this.channel) {
                this.$bus.$emit(this.channel, this.times)
            } else {
                console.log('Props channel is null!')
            }
        }
    },
}
</script>
